import { render, staticRenderFns } from "./ChangeTextHref.vue?vue&type=template&id=52b282da"
import script from "./ChangeTextHref.vue?vue&type=script&lang=js"
export * from "./ChangeTextHref.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports